import { Badge, Box, Button, Checkbox, FormControl, IconButton, MenuItem, Select, TableCell, TableHead, TableRow, TextField, Typography, useTheme } from "@mui/material";
import TemplateLoaderComponent from "../../../loader/TemplateLoaderComponent";
import { CancelOutlined, CheckCircleOutlined, PeopleAltOutlined, SearchOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useApplicationContext } from "../../../../context/ApplicationContext";
import { useEffect } from "react";
import { TableVirtuoso } from "react-virtuoso";
import { TableComponents } from "../../../common/previewTemplate/StaticComponents";
import { formatDate } from "../../../../utils/DateTime";


import ConfirmationDialog from "../../../dialog/ConfirmationDialog";
import CreateAddOnLicenseComponent from "./create";
import { deleteLicenseAddOn_API, getLicenseAddOnList_API } from "../../../../api/controller/LicenseController";
import { HttpStatusCode } from "axios";
import { Severity } from "../../../../constant/ApplicationVariables";
import useErrorHandler from "../../../../api/errorHandler/useErrorHandler";
import EditAddOnLicenseComponent from "./edit";
import BadgeComponent from "../../../common/Badge";
import { debounce } from "../../../../utils/Functions";
import DeleteConfirmationDialog from "../../../dialog/DeleteConfirmationDialog";



let dummyList = [
    {
        name: "Add-on 1",
        unitPrice: 10,
        chargedPerUnit: true,
        createdAt: "2024-06-20T12:34:56Z"
    },
    {
        name: "Add-on 2",
        unitPrice: 20,
        chargedPerUnit: false,
        createdAt: "2024-06-21T12:34:56Z"
    }
]




export default function LicenseAddOnContainer() {
    const {
        handleSnackbar,
        organisationList,
        setOrganisationList,
        currentOrganisationData,
        setCurrentOrganisationData,
        licenseList,
        setLicenseList,
        currentLicenseData,
        setCurrentLicenseData,
        invoicesList,
        setInvoicesList,
        currentInvoiceData,
        setCurrentInvoiceData,
        openCreateOrganisationDialog,
        setOpenCreateOrganisationDialog,
        openEditOrganisationDialog,
        setOpenEditOrganisationDialog,
        openDeleteOrganisationDialog,
        setOpenDeleteOrganisationDialog,
        openCreateLicenseDialog,
        setOpenCreateLicenseDialog,
        openEditLicenseDialog,
        setOpenEditLicenseDialog,
        openDeleteLicenseDialog,
        setOpenDeleteLicenseDialog
    } = useApplicationContext();
    const theme = useTheme();
    const errorHandler = useErrorHandler();


    const [loading, setLoading] = useState(false);
    const [openLicenseAssignDialog, setOpenLicenseAssignDialog] = useState(false);
    const [searchText, setSearchText] = useState(""); // to store the search text
    const [statusFilterText, setStatusFilterText] = useState(""); // To store the active field status filter value
    const [selectedItemsList, setSelectedItemsList] = useState([]); // To store the checkbox selected items
    const [filteredList, setFilteredList] = useState([]); // To store the filtered list, after search and applying filter




    const handleChangeSearchTerm = (e) => {
        setSearchText(e.target.value);
    }


    // Functions to handle the assigned users dialog events
    const handleToggleLicenseAssignDialog = () => {
        if (!openLicenseAssignDialog) {
            setOpenLicenseAssignDialog(true);
        } else {
            setOpenLicenseAssignDialog(false);
        }
    }

    const handleContinueLicenseAssignDialog = () => { }


    // Functions to handle the create organisation dialog events
    const handleCloseCreateDialog = () => {
        setOpenCreateLicenseDialog(false);
    }

    const handleConfirmCreateDialog = () => {
        handleGetList()
    }


    const handleCloseEditDialog = () => {
        setOpenEditLicenseDialog(false);
        setCurrentLicenseData(null);
    }
    const handleConfirmEditDialog = () => {
        handleCloseEditDialog();
    }




    const handleCloseDeleteDialog = () => {
        setOpenDeleteLicenseDialog(false);
        setCurrentLicenseData(null);
    }
    const handleConfirmDeleteDialog = () => {
        handleDeleteItem();
    }


    const handleDeleteItem = async () => {
        setLoading(true);
        try {
            let query = `/${currentLicenseData?.code}`
            const response = await deleteLicenseAddOn_API(query);
            if (response) {
                errorHandler(response, setLoading);
            }
            if (response.status === HttpStatusCode.Ok) {
                handleSnackbar(response?.message || "Add-on Deleted Successfully", Severity.success)
                handleGetList();
            }
        } catch (error) {
            console.log(error, error?.message, "projectreponse errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setLoading(false);
        }
    }




    const handleGetList = async () => {
        setLoading(true);
        try {
            let query = `active=false`
            const response = await getLicenseAddOnList_API(query);
            if (response) {
                errorHandler(response, setLoading);
            }
            if (response.status === HttpStatusCode.Ok) {
                setLicenseList(response.data);

                if (openCreateLicenseDialog) {
                    handleCloseCreateDialog();
                }

                if (openDeleteLicenseDialog) {
                    handleCloseDeleteDialog()
                }
            }
        } catch (error) {
            console.log(error, error?.message, "projectreponse errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setLoading(false);
        }
    }




    useEffect(() => {
        handleGetList();
    }, []);

    // To filter the list, by search and filter
    useEffect(() => {
        let func = debounce(() => {
            let list = [...licenseList];
            if (statusFilterText === "true") {
                list = list.filter((item) => item.active === true);
            } else if (statusFilterText === "false") {
                list = list.filter((item) => item.active === false);
            }
            if (searchText) {
                list = list.filter((item) => item.name.toLowerCase().includes(searchText.toLowerCase()));
            }
            setFilteredList(list);
        }, 500);
        func();
    }, [searchText, statusFilterText, licenseList]);


    /* invoices - /admin/payments
    Get : to get all invoices

    public class AllInvoiceListDTO {

    private String companyName;
    private List<InvoiceDTO> invoices;
}


invoice parent list data : {
private String invoiceNumber;
    private BigDecimal totalAmount;
    private BigDecimal paidAmount;
    private BigDecimal balanceAmount;
    private InvoiceStatus status;
    private Instant issueDate;
    private List<InvoiceItemDTO> items;
    private List<PaymentDTO> payments;
}

invoice list child data : {
private String description;
    private BigDecimal quantity;
    private BigDecimal unitPrice;
    private BigDecimal subtotal;
    private BigDecimal taxRate;
    private BigDecimal taxAmount;
    private BigDecimal total;
}



       mark invoice : /mark
       post: api give on whatsapp.



    */








    // 
    // 
    // private String invoiceNumber;
    //     private BigDecimal totalAmount;
    //     private BigDecimal paidAmount;
    //     private BigDecimal balanceAmount;
    //     private InvoiceStatus status;
    //     private Instant issueDate;
    //     private List<InvoiceItemDTO> items;
    //     private List<PaymentDTO> payments;


    // private String description;
    //     private BigDecimal quantity;
    //     private BigDecimal unitPrice;
    //     private BigDecimal subtotal;
    //     private BigDecimal taxRate;
    //     private BigDecimal taxAmount;
    //     private BigDecimal total;

    //



    /*
    organisation : /admin/company



get: list of organisation

post : to create organistaion we have to give user details same as user register, company name of the organisation.
body : {
public class UserRegisterDTO {
	
    private String firstName;
    private String lastName;
	
    private String email;
    private String password;	// not required
    private String phone;
	
    private String companyName;
    
	
}
}

PUT : 
body : {

public class AdminUpdateCompanyDTO {

    private Integer companyId; // requrired
	
    private String name; // requrired
    private BigDecimal creditLimit;   // enter any number
    private PaymentTerms paymentTerms; // prepaid, postpaid
     private Integer allowedOverdue; // super admin can enter an amount here
}
    }



    GET list response : [
    {
    public class CompanyDTO {

    private Integer id;
    private String name;
    private BigDecimal creditLimit;
    private PaymentTerms paymentTerms;
    private Integer allowedOverdue; // super admin can enter an amount here
    private Instant createdAt;
    private boolean trialAllocated;  // super admin can set this, on when no organisation having no license.
}

    }
    ]



    enum = PREPAID, POSTPAID;






    organisation trail: to give trail license to organisation
     base url : /trial
    
    */


    return (
        <Box className="  flex-1 flex flex-col gap-4 overflow-hidden relative " >
            {loading && <TemplateLoaderComponent />}
            <Box className="flex-1 flex flex-col gap-4 px-4 py-0 overflow-y-auto">


                <Box className="flex items-center gap-4">
                    <TextField type="search" placeholder="Search" slotProps={{ input: { startAdornment: <SearchOutlined /> } }} defaultValue={searchText} onChange={handleChangeSearchTerm} />
                    <FormControl className="w-40">
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            displayEmpty
                            name="active"
                            value={statusFilterText}
                            onChange={(e) => setStatusFilterText(e.target.value)}
                        >
                            <MenuItem value="">All Status</MenuItem>
                            <MenuItem value="true">Active</MenuItem>
                            <MenuItem value="false">Inactive</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Box className="flex-1 flex flex-col gap-4">
                    <TableComponent list={filteredList} selectedItemsList={selectedItemsList} setSelectedItemsList={setSelectedItemsList} />
                </Box>
            </Box>


            {openCreateLicenseDialog && (
                <CreateAddOnLicenseComponent open={openCreateLicenseDialog} handleClose={handleCloseCreateDialog} handleContinue={handleConfirmCreateDialog} />
            )}

            {openEditLicenseDialog && currentLicenseData && (
                <EditAddOnLicenseComponent open={openEditLicenseDialog} handleClose={handleCloseEditDialog} handleContinue={handleConfirmEditDialog} data={currentLicenseData} />
            )}

            {openDeleteLicenseDialog && currentLicenseData && (
                <DeleteConfirmationDialog open={openDeleteLicenseDialog} data={`${currentLicenseData?.name}`} title={"Delete License Add-on"} description={"Are you sure you want to delete this license add-on?"} handleClose={handleCloseDeleteDialog} handleContinue={handleConfirmDeleteDialog} />
            )}

        </Box>
    )
}


function TableComponent({ list, selectedItemsList, setSelectedItemsList, }) {
    const { currentLicenseData, setCurrentLicenseData, openEditLicenseDialog, setOpenEditLicenseDialog, openDeleteLicenseDialog, setOpenDeleteLicenseDialog } = useApplicationContext();
    const theme = useTheme();


    const [localList, setLocalList] = useState([]); // to store the list locally




    const handleChangeCheckbox = (e, data) => {
        let foundItem = selectedItemsList?.find((item) => item?.code === data?.code);

        if (e.target.name === "selectAll") {
            if (selectedItemsList?.length === list?.length) {
                setSelectedItemsList([]);
            } else {
                setSelectedItemsList(list?.filter((item) => item?.code !== data?.code));
            }

        } else {

            setSelectedItemsList(
                e.target.checked && !foundItem
                    ? [...selectedItemsList, data]
                    : selectedItemsList.filter((item) => item?.code !== data?.code)
            );
        }
    }


    const table_columns = [
        {
            data: <Checkbox name="selectAll" checked={selectedItemsList?.length > 0 && selectedItemsList?.length === list?.length} indeterminate={selectedItemsList?.length > 0 && selectedItemsList?.length < list?.length} onChange={handleChangeCheckbox} />,
            dataKey: "checkbox",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "60px",
                maxWidth: "60px",
                border: "0px solid #000"
            },
        },
        // {
        //     data: "S.No.",
        //     dataKey: "index",
        //     padding: "none",
        //     px: "0.2rem",
        //     align: "center",
        //     background: theme.palette.header.main,

        //     sx: {
        //         minWidth: "40px",
        //         maxWidth: "40px",
        //         border: "0px solid #000"
        //     },
        // },
        {
            data: "Name",
            dataKey: "name",
            padding: "none",
            px: "0.2rem",
            align: "left",
            background: theme.palette.header.main,

            sx: {
                minWidth: "180px",
                width: "100%",
                maxWidth: "100%",
                border: "0px solid #000"
            },
        },
        // {
        //     data: "Description",
        //     dataKey: "description",
        //     padding: "none",
        //     px: "0.2rem",
        //     align: "left",
        //     background: theme.palette.header.main,

        //     sx: {
        //         minWidth: "180px",
        //         width: "100%",
        //         maxWidth: "100%",
        //         border: "0px solid #000"
        //     },
        // },
        {
            data: "Price",
            dataKey: "unitPrice",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "100px",
                maxWidth: "100px",
                border: "0px solid #000"
            },
        },
        {
            data: "Charged Per Unit",
            dataKey: "chargedPerUnit",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "160px",
                maxWidth: "160px",
                border: "0px solid #000"
            },
        },
        {
            data: "Status",
            dataKey: "active",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "100px",
                maxWidth: "100px",
                border: "0px solid #000"
            },
        },
        {
            data: "Created At",
            dataKey: "createdAt",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,

            sx: {
                minWidth: "120px",
                maxWidth: "120px",
                border: "0px solid #000"
            },
        },
        {
            data: "Action",
            dataKey: "action",
            padding: "none",
            px: "0.2rem",
            align: "center",
            background: theme.palette.header.main,
            sx: {
                minWidth: "160px",
                maxWidth: "160px",
                border: "0px solid #000"
            },
        }

    ];



    const handleOpenEditDialog = (data) => {
        setCurrentLicenseData(data);
        setOpenEditLicenseDialog(true);
    }





    // Functions to handle item delete
    const handleRemoveItem = (e, data, key) => {
        handleOpenDeleteDialog(data);
    }

    const handleOpenDeleteDialog = (data) => {
        setCurrentLicenseData(data);
        setOpenDeleteLicenseDialog(true);
    }






    // set the list
    useEffect(() => {
        if (list) {
            setLocalList(list)
        }
    }, [list]);



    return (
        <Box className="flex-1 flex flex-col gap-4">


            <TableVirtuoso
                style={{ height: "100%", width: "100%", overflowX: 'auto', borderRadius: theme.shape.borderRadius, boxShadow: "none", border: `1px solid ${theme.palette.divider}` }}
                data={localList}
                components={TableComponents}
                fixedHeaderContent={() => (
                    <TableHead>
                        {
                            table_columns?.map((item, index, arr) => (
                                <TableCell
                                    key={index}
                                    align={item?.align}
                                    padding={item?.padding}
                                    className="whitespace-nowrap"
                                    sx={{
                                        py: 0.5,
                                        margin: "0 0rem !important",
                                        background: item?.background,
                                        ...item?.sx,
                                        borderBottom: `1px solid ${theme.palette.divider}`,
                                    }}
                                >
                                    <Box className="py-1 flex items-center gap-2 min-w-full " sx={{ px: item?.px }}>
                                        <Typography className="flex-1 whitespace-nowrap" textAlign={item?.align} color="textPrimary" > {item?.data}</Typography>
                                    </Box>
                                </TableCell>
                            ))
                        }
                    </TableHead>
                )}


                itemContent={(itemIndex, itemData) => (
                    <TableRow className="cursor-pointer">

                        {
                            table_columns?.map((item, index, arr) => {
                                console.log(itemData[item?.dataKey], itemData, item, "dataKey")
                                return (
                                    <TableCell padding={item?.padding} align={item?.align} sx={{ py: 0.5, cursor: item?.dataKey === "title" && "pointer", ...item?.sx }} >
                                        {
                                            item?.dataKey === "index" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">{itemIndex + 1}.</Typography>
                                                </Box>
                                            ) : item?.dataKey === "checkbox" ? (
                                                <Box className="flex items-center justify-center py-1 gap-2 " sx={{ px: item?.px }}>
                                                    <Checkbox name="list" value={itemData?.code} checked={selectedItemsList?.some((item) => item?.code === itemData?.code)} onChange={(e) => handleChangeCheckbox(e, itemData)} />
                                                </Box>
                                            ) : item?.dataKey === "name" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1 line-clamp-2">{itemData[item?.dataKey]}</Typography>
                                                </Box>
                                            ) : item?.dataKey === "unitPrice" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">${itemData[item?.dataKey] ? itemData[item?.dataKey] : 0}</Typography>
                                                </Box>
                                            ) : item?.dataKey === "chargedPerUnit" ? (
                                                <Box className="flex items-center py-1 " sx={{ justifyContent: item?.align === "left" ? "flex-start" : item?.align === "right" ? "flex-end" : "center", px: item?.px }}>
                                                    {itemData[item?.dataKey] ? <CheckCircleOutlined color="success" /> : <CancelOutlined color="error" />}
                                                </Box>
                                            ) : item?.dataKey === "description" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} className="flex-1 line-clamp-2">{itemData[item?.dataKey]}</Typography>
                                                </Box>
                                            ) : item?.dataKey === "active" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    {/* <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">{itemData[item?.dataKey] ? "Active" : "Inactive"}</Typography> */}
                                                    <BadgeComponent text={itemData[item?.dataKey] ? "Active" : "Inactive"} />
                                                </Box>
                                            ) : item?.dataKey === "features" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }} title={`${itemData[item?.dataKey]?.map((item) => item).join(", ")}`}>
                                                    <Typography textAlign={item?.align} className="flex-1 line-clamp-2">{itemData[item?.dataKey]?.map((item) => item).join(", ")}</Typography>
                                                </Box>
                                            ) : item?.dataKey === "createdBy" ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} fontWeight={"bold"} className="flex-1">{itemData[item?.dataKey]?.name}</Typography>
                                                </Box>
                                            ) : (item?.dataKey === "createdAt" || item?.dataKey === "lastModifiedAt" || item?.dataKey === "closureDate" || item?.dataKey === "impactDate") ? (
                                                <Box className="flex items-center py-1 " sx={{ px: item?.px }}>
                                                    <Typography textAlign={item?.align} className="flex-1">{itemData[item?.dataKey] ? formatDate(itemData[item?.dataKey]) : "-"}</Typography>
                                                </Box>
                                            ) : (item?.dataKey === "action") ? (
                                                <Box className="flex items-center py-1 gap-1 " sx={{ justifyContent: item?.align === "left" ? "flex-start" : item?.align === "right" ? "flex-end" : "center", px: item?.px }}>
                                                    {/* <Button color="info" disabled={true}>Resend</Button> */}
                                                    {/* <Button color="info">Assign Project</Button> */}
                                                    <Button color="info" variant="outlined" onClick={(e) => handleOpenEditDialog(itemData)}>Edit</Button>
                                                    <Button color="error" variant="outlined" onClick={() => handleOpenDeleteDialog(itemData)}>Delete</Button>
                                                </Box>
                                            )
                                                : (
                                                    <Box className="flex-1 flex items-center  py-1  " sx={{ px: item?.px }}>
                                                        <Typography textAlign={item?.align} className="flex-1">{itemData[item?.dataKey] ? itemData[item?.dataKey] : "-"}</Typography>
                                                    </Box>
                                                )
                                        }
                                    </TableCell>
                                )
                            })
                        }

                    </TableRow>

                )}
            />




        </Box>
    )
}